<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini" ref="form">
            <el-form-item label="asin：" class="query-form-item">
                <el-input v-model="query.asin" placeholder="请输入asin"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :height="tableHeight" v-loading="loading" :data="list" stripe border style="width: 100%">
            <el-table-column prop="id" label="ID" width="100" align="center"/>
            <el-table-column label="商品图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.img_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                </template>
            </el-table-column>
            <table-asin-column></table-asin-column>
            <el-table-column label="采购人员" width="120" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.developer_username }} <br/>
                        {{ scope.row.developer_full_name }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="类目" width="200" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category }}</div>
                </template>
            </el-table-column>


            <el-table-column label="1688产品价格" min-width="110" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_factory_price }}</div>
                </template>
            </el-table-column>


            <el-table-column label="1688产品链接" min-width="150" align="center">
                <template slot-scope="scope">
                    <el-button v-show="scope.row.ali_href_link" type="primary" size="mini"
                               @click="jumpUrl(scope.row.ali_href_link)">跳转
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="规格-长(cm)" width="100" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.long }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="规格-宽(cm)" width="100" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.wide }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="规格-高(cm)" width="100" align="center">
                <template slot-scope="scope">
                    <div>
                        {{scope.row.height}}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="规格-重(g)" width="100" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.weight }}
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="包装物-名称" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.wrappage }}</div>
                </template>
            </el-table-column>
            <el-table-column label="包装物-长" width="100" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.wrappage_long}}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="包装物-宽" width="100" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.wrappage_wide }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="包装物-高" width="100" align="center">
                <template slot-scope="scope">
                    <div>
                        {{scope.row.wrappage_height }}
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="包装物-链接" align="center" :show-overflow-tooltip="true" width="160">
                <template slot-scope="scope">

                    <el-button v-show="scope.row.wrappage_link" type="primary" size="mini"
                               @click="jumpUrl(scope.row.wrappage_link)">跳转
                    </el-button>

                </template>
            </el-table-column>

            <el-table-column label="采购规格备注" align="center" :show-overflow-tooltip="true" width="200">
                <template slot-scope="scope">
                    <span>{{ scope.row.purchase_specification_remark }}</span>
                </template>
            </el-table-column>
            <el-table-column label="备注" align="center" :show-overflow-tooltip="true" width="200">
                <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>
        </el-table>


        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>

    </div>

</template>

<script>
    import {downloadFileUrl} from '@/utils/method'
    import * as api from '@/api/advAnalys/advAnalys.js'
    import {competing_asin_attribute_lists} from '@/api/advAnalys/advAnalys.js'

    export default {
        data() {
            return {
                tableHeight: null,
                addSubLibraryModal: false,
                query: {
                    asin: '',
                    page: 1,
                    limit: 20
                },
                list: [],
                total: 0,
                loading: true,
                authList: [],
                defaultProps: {
                    children: 'children',
                    label: 'title'
                },
                authLoading: false,
                authFormVisible: false,
                authFormData: {
                    role_id: '',
                    auth_rules: []
                },
                authDefaultCheckedKeys: [],
                index: null,
                formName: null,
                formMap: {
                    add: '新增角色',
                    edit: '编辑'
                },
                formLoading: false,
                formVisible: false,
                formRules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'}
                    ],
                    status: [
                        {required: true, message: '请选择状态', trigger: 'change'}
                    ]
                },
                deleteLoading: false
            }
        },
        methods: {
            jumpUrl(url) {
                if (url) {
                    window.open(url, '_blank')
                } else {
                    this.$message.warning('没有链接')
                }
            },
            handleDetail(index, data) {
                this.$refs.shipmentDetailRef.showModal(data)
            },
            // 关闭弹窗回调
            closeCllback(isShow) {
                this.addSubLibraryModal = false
                isShow == true && this.getList()
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            onReset() {
                this.query = {
                    asin: '',
                    page: 1,
                    limit: 20
                }
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            uploadFunc() {
                this.addSubLibraryModal = true
            },
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                api.competing_asin_attribute_lists(this.query)
                    .then(response => {
                        this.loading = false
                        this.list = response.data.list || []
                        this.total = response.data.total || 0
                    })
                    .catch(() => {
                        this.loading = false
                        this.list = []
                        this.total = 0
                    })
            },
        },
        mounted() {
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            140 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
        },
        created() {
            // 加载表格数据
            this.getList()
        }
    }
</script>
